import { useState, useCallback } from "react";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import OverviewSection from "./components/OverviewSection";
import CalendarSection from "./components/CalendarSection";
import TimetableViewer from "./components/TimetableViewer";
import CommandsSection from "./components/CommandsSection";
import IntegrationSection from "./components/IntegrationSection";
import SupportSection from "./components/SupportSection";
import Footer from "./components/Footer";
import OpeningAnimation from "./components/OpeningAnimation";

export default function Home() {
  const [openingDone, setOpeningDone] = useState(false);

  const handleOpeningComplete = useCallback(() => {
    setOpeningDone(true);
  }, []);

  return (
    <div className="min-h-screen" style={{ fontFamily: "'Inter', sans-serif" }}>
      {!openingDone && <OpeningAnimation onComplete={handleOpeningComplete} />}
      <Navbar />
      <main>
        <HeroSection />
        <OverviewSection />
        <CalendarSection />
        <TimetableViewer />
        <CommandsSection />
        <IntegrationSection />
        <SupportSection />
      </main>
      <Footer />
    </div>
  );
}
